<div class="banner-container" (click)="trackBanner()" *ngIf="!user?.listsubscriptions?.medical">
  <div class="banner-text">
    <div class="banner-title">
      save a child every month
    </div>
    <div class="banner-subtitle">Join <strong>{{subsCount?.monthlyDonors | inrFormat}}</strong> monthly contributors with Social Impact Plan & start saving needy children every month</div>
    <div class="btn-container">
      <button mat-raised-button><span>Start Giving Monthly</span><em class="material-icons">arrow_forward</em></button>
    </div>
  </div>
  </div>

<!-- Banner for Sip-Subscribed user -->

<div class="banner-container-v2" *ngIf="user?.listsubscriptions?.medical">
  <div class="banner-text-v2">
    <div class="banner-title-v2">
        Browse Fundraisers
    </div>
    <div class="banner-subtitle-v2">
        Choose from <span>{{ vars.fundraiserCount }}</span> fundraisers to support
    </div>
  </div>
 </div>





